// ** UseJWT import to get config
import useJwt from '@src/auth/jwt/useJwt'
import { isParentUser, parseRolesPermissions } from '@src/auth/utils'
import { emptyCache } from '@utils'
import { getCompany } from '../../../views/desplegable-admin/empresas/store/action'
import { getNavUsersData, updateUserSinMensaje, setClienteTarifa } from '@src/views/usuario/store/action'
import { changeGerenteSuper, obtenerFiltrosPantalla, addToCart, setFilters } from '@src/views/productos/store/actions'
import { settings, ParametrosGlobalesControllerApi } from '@api/backend'

const config = useJwt.jwtConfig
const prefix = 'auth'

// ** Handle User Logout
export const handleLogout = () => {
  return dispatch => {
    // limpio el localStorage
    localStorage.clear()
    console.log('LocalStorage eliminado')
    
    // Limio la caché y espero a que devuelva la respuesta para luego hacer el dispatch
    emptyCache().then(() => {
      dispatch({ 
        type: `${prefix}/LOGOUT`, 
        [config.storageTokenKeyName]: null, 
        [config.storageRefreshTokenKeyName]: null 
      })
    }).catch((error) => {
      console.error("Error al vaciar el cache: ", error)
    })
  }
}

export const handleLogoutasync = async () => {
  return dispatch => {
    dispatch({ type: `${prefix}/LOGOUT`, [config.storageTokenKeyName]: null, [config.storageRefreshTokenKeyName]: null })
    localStorage.clear()
    emptyCache()
  }
}

// ** Handle User Login
export const handleLogin = data => {
  return async dispatch => {
    const apiParametrosGlobales = new ParametrosGlobalesControllerApi(settings)
    await handleLogoutasync()
    await dispatch(changeGerenteSuper('off'))
    //emptyCache() //Limpiar cache cuando se hace rebuild
    await dispatch({
      type: `${prefix}/LOGIN`,
      data,
      config,
      [config.storageTokenKeyName]: data[config.storageTokenKeyName],
      [config.storageRefreshTokenKeyName]: data[config.storageRefreshTokenKeyName]
    })
    // Obtengo la compañia para trabajar con ella mas adelante
    //dispatch(getCompany(data.companyId))
    localStorage.setItem('empresaID', data.companyId)
    let isParent
    if (data.tipoUsuario === "V") {
      isParent = await isParentUser(data.clienteDefecto)
    }
    if (data.tipoUsuario === "C") {
      isParent = await isParentUser(data.codVendedorCliente)
    }
    // ** Add to user, accessToken & refreshToken to localStorage
    localStorage.setItem('userData', JSON.stringify({ ...data, ability: parseRolesPermissions(data.roles.rolesPermissions), isParent }))
    localStorage.setItem(config.storageTokenKeyName, data.accessToken)
    localStorage.setItem(config.storageRefreshTokenKeyName, data.refreshToken)

    if (data.tipoUsuario === "V") {
      const response = await dispatch(getNavUsersData())
      if (response !== undefined) {
        try {
          //
          //Buscamos el código de vendedor 
          //
          const salePerson = response.find((el) => el.code === data.codVendedorCliente)
          let usuario 
          //
          //Si el valor del descuento de BC está establecido lo pongo, en caso contrario le pongo un 0
          //
          if (salePerson !== null && salePerson !== undefined) {
            usuario = {
              maximoDescuento: salePerson.maxdiscountallowed
            }
          } else {
            usuario = {
              maximoDescuento: 0
            }
          }
          //
          //Actualizo la información en la BBDD
          //
          dispatch(updateUserSinMensaje(Number(data.id), usuario))
        } catch (error) {
          console.log(error)  
          
        }
      }
    }
    const response = await apiParametrosGlobales.parametrosGlobalesControllerFind()
    if (response.data.length > 0) {
      localStorage.setItem('tiempoDeEsperaInactividad', response.data[0].minutosCierreSesion)
    } else {
      localStorage.setItem('tiempoDeEsperaInactividad', 5)
    }

    // asignamos el cliente por defecto al usuario
    await dispatch(setClienteTarifa({value: data.clienteDefecto}))
    // Cargamos los filtros de la pantalla de productos y los seteamos en el store
    const filtrosGuardados = await obtenerFiltrosPantalla(data.id, 'productos'); 
    await dispatch(setFilters(filtrosGuardados))

    setTimeout(async () => {
      try {
        const response = await obtenerFiltrosPantalla(data.id, 'carrito');
    
        if (response && Array.isArray(response)) {
          await Promise.all(response.map(async (item) => {
            if (item.sku) {
              await dispatch(addToCart(item.sku, '', '', '', item));
            }
          }));
        }
    
        console.log("ha cargado obtenerFiltrosPantalla");
      } catch (error) {
        console.log(error);
      }
    }, 2000); // ESPERAMOS 2 SEGUNDOS, PARA QUE CARGUE TODAS LAS VARIABLES DEL LOGIN ANTES DE EJECUTAR EL CARRITO
    return true
  }
}


// ** Handle setear permisos
export const handlePermisos = (permisos) => {
  return dispatch => {
    dispatch({ type: `${prefix}/PERMISOS`, data: permisos })
  }
}
